<!-- 新帮助中心 -->
<template>
  <div class="newHelpBox">
    <Nav />
    <div class="newHelp">
      <!-- banner -->
      <div class="banner">
        <h1 class="wow animate__animated animate__rollIn ">步峰代理帮助中心</h1>
        <div class="_search">
          <el-input
            placeholder="请输入问题关键字"
            v-model="searchInput"
            class="input-with-select"
            @keyup.enter.native="jumpSearch"
          >
            <el-button @click.stop="jumpSearch()" type="success" slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>
      <!-- 了解步峰代理及产品 -->
      <div class="understand">
        <div class="title">
          <span>{{ topData.category_name }}</span>
          <span class="more-btn" v-if="topData.article.length > 7" @click="goCategory(topData.article[0])">
            更多
            <span class="arrow">></span>
            <span class="arrow">></span>
            <span class="arrow">></span>
          </span>
        </div>
        <div class="list" v-if="topData.article.length > 0">
          <div class="_li" v-for="(item,index) in topData.article.slice(0, 7)" :key="index" @click.stop="jumpDetail(item.id)">
            <img :src="item.thumb" alt="">
            <p>{{item.title}}</p>
          </div>
        </div>
      </div>
      <div class="FAQ" v-for="(item, index) in ArticleList" :key="index">
        <div class="title">
          <span>{{ item.name }}</span>
          <span class="more-btn" v-if="item.articles.length > 8" @click="goCategory(item.articles[0])">
            更多
            <span class="arrow">></span>
            <span class="arrow">></span>
            <span class="arrow">></span>
          </span>
        </div>
        <div class="_list" v-if="item.articles.length > 0">
          <div
            class="_li" 
            v-for="(j,k) in item.articles.slice(0, 8)" 
            :key="k" 
            @click.stop="jumpDetail(j.id)"
          >
            {{j.title}}
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { WOW } from 'wowjs' 
import Foot from '@/components/Foot.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
  name: 'newHelp',
  components: {
    Nav,
    Foot
  },
  data(){
    return {
      searchInput:'',
      topData:{
        article: []
      },
      ArticleList:[]
    }
  },
  created(){
    if(this.$route.query.search){
      this.searchInput = this.$route.query.search
    }
    this.getReadShowArticleImg()
    this.getReadHotArticleList()
  },
  methods:{
    goCategory(data) {
      this.$router.push({ 
				path: `/newhelpdetail`,
				query: {
					id: data.id
				}
			})
    },
    getReadHotArticleList(data){
      request({
				method: "get", 
				url: Apis.readHotArticleList,
        params:data,
        _type:1,
			}).then(res => {
				if(res.code == 0){
					this.ArticleList = res.data
				}else{
					this.$message.error(res.msg);
				}
			});
    },
    getReadShowArticleImg(data){
      request({
				method: "get", 
				url: Apis.readShowArticleImg,
        params:data,
        _type:1,
			}).then(res => {
				if(res.code == 0){
					this.topData = res.data
				}else{
					this.$message.error(res.msg);
				}
			});
    },
    jumpDetail(id){
      this.$router.push({ 
				path: `/newhelpdetail`,
				query: {
					id: id
				}
			})
    },
    jumpSearch(){
      if (this.searchInput === '' || !this.searchInput){
        this.$message({
					message: '请输入问题关键字',
					showClose: true,
					duration:1500,
          type: 'warning'
				});
      } else {
        this.$router.push({ 
				  path: `/newhelpsearch`,
          query: {
            search: this.searchInput
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.newHelpBox{
  width: 100%;
  .newHelp{
    width: 100%;
    .banner{
			width: 100%;
			height: 284px;
			background: url('../assets/newHelpBg.png')no-repeat;
			background-size: 100% 100%;
			h1,h3{
				width: 100%;
				color: #fff;
				text-align: center;  
				text-shadow: -2px 2px 0px #616161;
			}
			h1{
				font-size: 43px;
				font-weight: bold;
				padding-top: 68px;
			}
      ._search{
        width: 472px;
        height: 35px;
        margin: 0 auto;
        margin-top: 23px;
      }
      ._hot{
        width: 420px;
        height: 30px;
        margin: 0 auto;
        margin-top: 15px;
        display: flex;
        justify-content: left;
        ._hot_sear{
          font-size: 14px;
          color: #fff;
          position: relative;
          line-height: 30px;
        }
        ._hot_sear::before{
          display: inline-block;
          content: '';
          width: 15px;
          height: 18px;
          background: url('../assets/hot.png')no-repeat;
          background-size: 100%;
          position: absolute;
          left: -20px;
          top: 4px;
        }
        ._hot_issue{
          padding:8px 17px ;
          border-radius: 100px;
          background: rgba(255, 255, 255, 0.2);
          line-height: 15px;
          color: #fff;
          font-size: 14px;
          margin-left: 21px;
        }
      }
    }
    .understand{
      width: 1200px;
      margin: 0 auto;
      .list{
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fit, 165px);
        grid-template-rows: repeat(1, 125px);
        justify-content: start;
        column-gap: 20px;
        &:has(> ._li:nth-child(4)) {
          justify-content: space-between;
          column-gap: 0;
        }
        ._li{
          width: 165px;
          height: 125px;
          position: relative;
          overflow: hidden;
          img{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;  
            transition: all 0.6s;  
            object-fit: cover;
            &:hover{  
              transform: scale(1.4);  
            } 
          }
          p{
            width: 100%;
            height: 33px;
            background: rgba(255, 255, 255, 0.9);
            position: absolute;
            bottom: 0;
            font-size: 14px;
            line-height: 33px;
            color: #1E1D1D;
            text-align: left;
            padding: 0 10px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }
      }
    }
    .FAQ{
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 30px;
      ._list{
        width: 100%;
        display: grid;
        grid-template-columns: repeat(4, 25%);
        grid-template-rows: repeat(2, 40px);
        ._li{
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
          color:#1E1D1D;
          text-align: left;
          cursor: pointer;  
          font-size: 14px;
          text-align: left;
          position: relative;
          line-height: 40px;
          padding: 0 10px;
          &::before{
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
            display: inline-block;
            width: 5px;
            height: 5px;
            background: #1F8EFF;
          }
          &:hover{
            color: #1F8EFF;
          }
        }
      }
    }
  }
}
.title{
  font-size: 18px;
  font-weight: bold;
  color: #1E1D1D;
  text-align: left;
  position: relative;
  left: 10px;
  margin:25px 0;
  &::before{
    display: inline-block;
    content: '';
    width: 4px;
    height: 18px;
    background: #1F8EFF;
    position: absolute;
    top: 4px;
    left: -10px;
  }
  .more-btn{
    margin-left: 50px;
    font-size: 14px;
    font-weight: normal;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 8px 14px;
    font-size: 14px;
    cursor: pointer;
    border: none;
    background: transparent;
    .arrow {
      display: inline-block;
      transition: transform 0.2s ease;
      &:nth-child(2) { transition-delay: 0.05s; }
      &:nth-child(3) { transition-delay: 0.1s; }
    }
    &:hover{
      color: #1890ff;
      .arrow {
        transform: translateX(4px);
      }
    }
  }
}
</style>